<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('countries.management')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="countries"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="!countries" loading-text="Chargement en cours..."
                >
                    <template v-slot:item._flag="{ item }">
                        <country-flag :country=" item._code " size='normal'/>
                    </template>
                    <template v-slot:item._code_iso_numerique="{ item }">
                        <v-chip :color="getColor(item._code_iso_numerique)" dark>{{ item._code_iso_numerique }}</v-chip>
                    </template>

                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn style="background: #29B3A6;color: #fff" class="mb-2" v-on="on">
                                        {{$t('countries.new')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>


                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                            <v-alert v-if="errors" dense outlined
                                                     :type="(errors.update_error)?'error':'success'">
                                                {{$t(errors.message)}}
                                            </v-alert>

                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>

                                            <v-row>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-autocomplete
                                                            :items="list_of_countries"
                                                            :label="$t('countries.name')"
                                                            :placeholder="$t('countries.name')"
                                                            v-model="editedItem._code"
                                                            :rules="nameRules"
                                                            @change="setCountryDetails"
                                                    ></v-autocomplete>
                                                    <!--<v-text-field :rules="nameRules" v-model="editedItem._code"
                                                                  :label="$t('countries.name')"></v-text-field>-->
                                                </v-col>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-text-field :rules="codeRules" v-model="editedItem._code"
                                                                  :label="$t('countries.code')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-text-field prefix="+" :rules="code_iso_numeriqueRules"
                                                                  v-model="editedItem._code_iso_numerique"
                                                                  :label="$t('countries.cin')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="dark"  @click="close">Annuler</v-btn>
                                        <v-btn color="primary"  @click="save">Enrégistrer</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="text-align:  right">
                          <v-menu
                                  key="text"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon

                                      class="black--text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(action_item, index) in actions_items"
                                            :key="index"
                                            link
                                            @click="editItemAction(item,index)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">{{action_item.avatar}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import helpers from "../../mixins/helpers";
    import countries from '../../resources/countries.json'
    import $ from 'jquery'
    export default {
        components: {
            CountryFlag
        },
        mixins:[helpers(this)],
        label: "Pays",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                search: '',
                dialog: false,
                id: undefined,
                errors:undefined,
                headers: [
                    {text: 'Drapeau', value: '_flag'},
                    {
                        text: 'Nom',
                        align: 'start',
                        sortable: true,
                        value: '_name',
                    },
                    {text: 'Code', value: '_code'},
                    {text: 'Préfixe', value: '_code_iso_numerique'},
                    {text: '', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    _name: '',
                    _code: '',
                    _file: '',
                    _code_iso_numerique: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _name: '',
                    _code: '',
                    _flag: '',
                    _code_iso_numerique: '',
                    _id: 0,
                    _created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'Code requis',
                ],
                code_iso_numeriqueRules: [
                    v => !!v || 'Code iso requis',
                ],
                actions_items: [
                    { title: "Régions", avatar: 'mdi mdi-view-list' },
                    { title: "Modifier", avatar: 'mdi-pencil' },
                    { title: "Supprimer", avatar: 'mdi-delete' }
                ],
            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('countries.new') : this.$t('countries.update')
            },
            list_of_countries:function(){
             let arr = [],VueBox = this;
            countries.forEach((country)=>{
                if ( VueBox.countries){
                    let exists = VueBox.countries.find(c=> c._code.toLowerCase()==country.iso2.toLowerCase());
                    if (this.editedIndex!==-1){
                        arr.push({text:country.name,value:country.iso2})
                    }else{
                        if (!exists)
                            arr.push({text:country.name,value:country.iso2})
                    }
                }
            });
        return arr;
    },
            ...mapState('countries/', ['countries'])
        }
        ,
        mounted() {
            this.$vuetify.goTo(0)
            $(document).scrollTop()
            this.$store.dispatch('countries/getCountries').then(response => {});
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {
                this.langues = [
                    {
                        name: 'Bénin',
                        code: 'BJ',
                        code_iso_numerique: 204

                    }
                ]
            },
            editItemAction(item,index) {
                switch (index){
                    case 0:
                        this.$router.push({name:'regions',params:{country_code:item._code}})
                        break;
                    case 1:
                        this.editItem(item)
                        break;
                    case 2:
                        this.deleteItem(item)
                        break;

                }
            },
            editItem(item) {
                this.editedIndex = this.countries.indexOf(item);
                this.editedItem._code = item._code.toUpperCase();
                this.editedItem._name = item._name;
                this.editedItem._file = item._flag;
                this.editedItem._code_iso_numerique = item._code_iso_numerique;
                this.editedItem._id = item._id;
                console.log(this.editedItem);
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                const index = this.countries.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29B3A6"
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('countries/deleteCountry', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            save() {
                /* if (this.checkIfLangueExist()!==undefined){
                     this.errors.operation=this.$t('countries.exist');
                     return;
                 }*/
                let VueBox = this;
                this.submitting = true;
                let data = new FormData();
                let code = this.editedItem._code.toLowerCase();
                data.append("code", code);
                data.append("name", this.editedItem._name);
                data.append("file", code);
                data.append("code_iso_numerique", this.editedItem._code_iso_numerique);
                let mineroute = 'countries/setCountry';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id)
                    mineroute = 'countries/updateCountry';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    VueBox.submitting = false;
                    if (response.data.error) {
                        VueBox.toast('error',response.data.message)
                    } else {

                        VueBox.toast('success',response.data.message)
                    }
                    VueBox.close();
                })
            },

            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code)
                }
            },
            getColor(calories) {
                if (calories > 230) return 'red'
                else if (calories > 200) return 'orange'
                else return 'green'
            },
            setCountryDetails(){
                let country =  countries.find(country=> country.iso2 == this.editedItem._code);
                this.editedItem._name = country.name;
                this.editedItem._code_iso_numerique = country.phone_code;
            },

        },

        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
